<template>
  <div class="estimateCard">
    <h3 class="title title_order">输入信息</h3>
    <p class="p_text font_bold">营养系统</p>
    <a-row :gutter="24">
      <a-col :span="8" v-for="el in inputNutritionSystem" style="height: 40px;" :key="el.feild">
        <div class="p_text">
          <span class="titleText">{{ el.name }}: </span>
          <a-tooltip>
            <template slot="title">
              {{ infor.id ? getText(el) : '-' }}
            </template>
            <span class="labelText">{{ infor.id ? getText(el) : '-' }}</span>
          </a-tooltip>
          {{el.unit}}
        </div>
      </a-col>
    </a-row>
    <p class="p_text font_bold">性别</p>
    <a-row :gutter="24">
      <div v-for="el in inputSex" :key="el.feild">
        <a-col :span="8" v-if="gender[el.feild]" style="height: 40px;">
          <div class="p_text">
            <span class="titleText">{{ el.name }}: </span>
            <a-tooltip>
              <template slot="title">
                {{ infor.id ? getText(el) : '-' }}
              </template>
              <span class="labelText">{{ infor.id ? getText(el) : '-' }}</span>
            </a-tooltip>
            {{el.unit}}
          </div>
        </a-col>
      </div>
    </a-row>
    <p class="p_text font_bold">采食量</p>
    <a-row :gutter="24">
      <div v-for="el in inputFeedIntake" :key="el.feild">
        <a-col :span="8" style="height: 40px;" :key="el.feild" v-if="feedIntake[el.feild]">
          <div class="p_text">
            <span class="titleText">{{ el.name }}: </span>
            <a-tooltip>
              <template slot="title">
                {{ infor.id ? getText(el) : '-' }}
              </template>
              <span class="labelText">{{ infor.id ? getText(el) : '-' }}</span>
            </a-tooltip>
            {{el.unit}}
            
          </div>
        </a-col>
      </div>
    </a-row>
    <p class="p_text font_bold">蛋白沉积模型</p>
    <a-row :gutter="24">
      <div v-for="el in inputProtein" :key="el.feild">
        <a-col :span="8" v-if="protein[el.feild]" style="height: 40px;">
          <div class="p_text">
            <span class="titleText">{{ el.name }}: </span>
            <a-tooltip>
              <template slot="title">
                {{ infor.id ? getText(el) : '-' }}
              </template>
              <span class="labelText">{{ infor.id ? getText(el) : '-' }}</span>
            </a-tooltip>
            {{el.unit}}
          </div>
        </a-col>
      </div>
      
    </a-row>
    <p class="p_text font_bold">观测的生长性能</p>
    <a-row :gutter="24">
      <div v-for="el in inputGrowthProperties" :key="el.feild">
        <a-col :span="8" :key="el.feild" v-if="growth[el.feild]" style="height: 40px;">
          <div class="p_text">
            <span class="titleText">{{ el.name }}: </span>
            <a-tooltip>
              <template slot="title">
                {{ infor.id ? getText(el) : '-' }}
              </template>
              <span class="labelText">{{ infor.id ? getText(el) : '-' }}</span>
            </a-tooltip>
            {{el.unit}}
            
          </div>
        </a-col>
      </div>
      
    </a-row>
    <p class="p_text font_bold">目标体重区间</p>
    <a-table
      :columns="columns"
      :data-source="list"
      class="estimateTable"
      :pagination="false"
      row-key="id"
    ></a-table>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import {
  inputNutritionSystem,
  inputSex,
  inputFeedIntake,
  inputProtein,
  inputGrowthProperties,
  inputColumns,
} from "../../EstimateConfig/estimateConfig";

export default {
   props: ['details'],
  data() {
    return {
      inputNutritionSystem,
      inputSex,
      inputFeedIntake,
      inputProtein,
      inputGrowthProperties,
      inputColumns,
      infor: {},
      columns: inputColumns,
      list: [],
      // 性别
      gender:{
        genderOption: true,
        giltsProportion: false,
        barrowsProportion: false,
        entireMalesProportion: false,
      },
      genderFilter: {
        giltsProportion: ['GENDER_OPTION_GILT_AND_BARROWS','GENDER_OPTION_GILT_AND_ENTIREMALE'],
        barrowsProportion: ['GENDER_OPTION_GILT_AND_BARROWS'],
        entireMalesProportion: ['GENDER_OPTION_GILT_AND_ENTIREMALE'],
      },
      // 蛋白
      protein:{
        currentPdPatternNumber: true,
        userDefinedMeanpd: false,
        pdMaxinput: false,
        bwatstartpdMaxdeclineinput: false,
      },
      proteinFilter: {
        userDefinedMeanpd: ['CURRENTPDPATTERNNUMBER_AVG_DP'],
        pdMaxinput: ['CURRENTPDPATTERNNUMBER_SPECIFY_DPMAXANDWEIGHT'],
        bwatstartpdMaxdeclineinput: ['CURRENTPDPATTERNNUMBER_SPECIFY_DPMAXANDWEIGHT'],
      },
      // 生长性能
      growth:{
        currentGrowthPerformanceNumber: true,
        startingBw: false,
        slaughterbw: false,
        probebackfatatfinal: false,
        daystarttosla: false,
      },
      growthFilter: {
        startingBw: ['CURRENTGROWTHPERFORMANCENUMBER_BTOTARGET_DAYS','CURRENTGROWTHPERFORMANCENUMBER_GMMCURVE','CURRENTGROWTHPERFORMANCENUMBER_POLYNOMIALCURVE'],
        slaughterbw: ['CURRENTGROWTHPERFORMANCENUMBER_BTOTARGET_DAYS','CURRENTGROWTHPERFORMANCENUMBER_GMMCURVE','CURRENTGROWTHPERFORMANCENUMBER_POLYNOMIALCURVE'],
        probebackfatatfinal: ['CURRENTGROWTHPERFORMANCENUMBER_BTOTARGET_DAYS','CURRENTGROWTHPERFORMANCENUMBER_GMMCURVE','CURRENTGROWTHPERFORMANCENUMBER_POLYNOMIALCURVE'],
        daystarttosla: ['CURRENTGROWTHPERFORMANCENUMBER_BTOTARGET_DAYS'],
      },
      // 采食量
      feedIntake: {
        feedintakeDividedByFeedintakeAndWastage: true,
        currentFeedIntakeOption: true,
        observedMeanIntakeCurvetype: false,
        actualMeanIntakeOrIntakeCurve: false,
        actualMeanFeedIntakeAndWastage: false,
        meanDietEnergyContent: false,
        bwinitialActualMeanIntakeInput: false,
        bwfinalActualMeanIntakeInput: false,
        considerEnvironmentalTemperature: false,
        envTemp: false,
        considerPigSpace: false,
        pigSpace: false,
      },
      feedIntakeFilter: {
        actualMeanIntakeOrIntakeCurve: ['CURRENTFEEDINTAKEOPTION_FORECAST'],
        observedMeanIntakeCurvetype: ['CURRENTFEEDINTAKEOPTION_FORECAST'],

        
        // actualMeanIntakeOrIntakeCurve: false,
        actualMeanFeedIntakeAndWastage: ['ACTUALMEANINTAKEORINTAKECURVE_ACTUALMEANINTAKE'],
        meanDietEnergyContent: ['ACTUALMEANINTAKEORINTAKECURVE_ACTUALMEANINTAKE'],
        bwinitialActualMeanIntakeInput: ['ACTUALMEANINTAKEORINTAKECURVE_ACTUALMEANINTAKE'],
        bwfinalActualMeanIntakeInput: ['ACTUALMEANINTAKEORINTAKECURVE_ACTUALMEANINTAKE'],


        considerEnvironmentalTemperature: ['CURRENTFEEDINTAKEOPTION_FORECAST'],
        envTemp: ['CURRENTFEEDINTAKEOPTION_OBSERVATION'],
        considerPigSpace: ['CURRENTFEEDINTAKEOPTION_FORECAST'],
        pigSpace: ['CURRENTFEEDINTAKEOPTION_OBSERVATION'],
      }
    };
  },
  watch:{
    details:{
      handler(data){
        let {proteinDpModel,growthPerformance,feedIntake,prediction,weightRangeFormulaList}=data
        this.infor={...proteinDpModel,...growthPerformance,...feedIntake,...prediction}
        //体重
        this.list=weightRangeFormulaList 
        this.list.forEach((item,index)=>item.f1='区间'+(index+1))
        this.showGender()
        this.showProtein()
        this.showGrowth()
        this.showFeedIntake()
      },
      deep:true
    }
  },
  computed: {
    ...mapState('estimate',['dataDictionary'])
  },
  mounted() {
    // this.getCode()
  },
  methods: {
    showGender(){
      // 性别控制显隐
      let {genderOption} = this.infor
      this.inputSex.forEach(el => {
        if(!el.filter && this.genderFilter[el.feild]) this.gender[el.feild] = this.genderFilter[el.feild].includes(genderOption)
      })
    },
    showProtein(){
      // 蛋白控制显隐
      let {currentPdPatternNumber} = this.infor
      this.inputProtein.forEach(el => {
        if(!el.filter && this.feedIntakeFilter[el.feild]) this.protein[el.feild] = this.feedIntakeFilter[el.feild].includes(currentPdPatternNumber)
      })
    },
    showGrowth(){
      // 生长性能控制显隐
      let {currentGrowthPerformanceNumber} = this.infor
      this.inputGrowthProperties.forEach(el => {
        if(!el.filter && this.growthFilter[el.feild]) this.growth[el.feild] = this.growthFilter[el.feild].includes(currentGrowthPerformanceNumber)
      })
    },
    showFeedIntake(){
      // 采食量控制显隐
      let {currentFeedIntakeOption,considerPigSpace,considerEnvironmentalTemperature,actualMeanIntakeOrIntakeCurve} = this.infor
      this.feedIntake = {
        feedintakeDividedByFeedintakeAndWastage: true,
        currentFeedIntakeOption: true,
        observedMeanIntakeCurvetype: currentFeedIntakeOption !== 'CURRENTFEEDINTAKEOPTION_FORECAST',
        actualMeanIntakeOrIntakeCurve: currentFeedIntakeOption !== 'CURRENTFEEDINTAKEOPTION_FORECAST',

        actualMeanFeedIntakeAndWastage: actualMeanIntakeOrIntakeCurve=== 'ACTUALMEANINTAKEORINTAKECURVE_ACTUALMEANINTAKE',
        meanDietEnergyContent: actualMeanIntakeOrIntakeCurve=== 'ACTUALMEANINTAKEORINTAKECURVE_ACTUALMEANINTAKE',
        bwinitialActualMeanIntakeInput: actualMeanIntakeOrIntakeCurve=== 'ACTUALMEANINTAKEORINTAKECURVE_ACTUALMEANINTAKE',
        bwfinalActualMeanIntakeInput: actualMeanIntakeOrIntakeCurve=== 'ACTUALMEANINTAKEORINTAKECURVE_ACTUALMEANINTAKE',

        considerEnvironmentalTemperature: currentFeedIntakeOption !== 'CURRENTFEEDINTAKEOPTION_OBSERVATION',
        envTemp: considerEnvironmentalTemperature,
        considerPigSpace: currentFeedIntakeOption !== 'CURRENTFEEDINTAKEOPTION_OBSERVATION',
        pigSpace: considerPigSpace,
      }
    },
    getText(el){
      let {feild,unit,codeKey} = el || {}
      let val = this.infor[feild]
      let filter = {}
      let str = ''
      if(this.dataDictionary[codeKey]){
        filter = this.dataDictionary[codeKey].find(el => el.dictKey === val) || {}
        str = filter.dictValue || '-'
      }else{
        if(unit === '%'){
          // str = val * 100
          str = val
        }else{
          str = val === true ? '是' : (val === false ? '否' : val)
        }
      }
      return str
    }
  },
};
</script>


<style lang="scss" scoped>
.p_text{
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.titleText{
  display: inline-block;
  line-height: 20px;
  padding-right: 10px;
}
.labelText{
  display: inline-block;
  max-width: calc(100% - 80px);
  // width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 20px;
}
</style>